import React from 'react'
import ReactDOM from 'react-dom'
import Playground from './Playground'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
// Platform base styles
import '../../src/index.css'
import './index.css'

// Expose to window for live code
window.React = React
window.ReactDOM = ReactDOM

const app = (
  <BrowserRouter>
    <Playground />
  </BrowserRouter>
)

ReactDOM.render(app, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js